import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { useI18n } from "../context/I18nContext";
import { useToast } from "./Toast";

export default function RatingStars({ meal, onRated }) {
  const { state, actions } = useApp();
  const { t } = useI18n();
  const { toast } = useToast();
  const [hover, setHover] = useState(0);
  const [saving, setSaving] = useState(false);

  const rate = async (value) => {
    if (!state.user) {
      toast(t("rateLoginRequired"), "error");
      return;
    }
    setSaving(true);
    try {
      const updated = await actions.rateRecipe(meal.id, value);
      onRated?.(updated);
      toast(t("ratingSaved"), "success");
    } catch (error) {
      toast(error.message, "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="rating-box">
      <span>{t("rateRecipe")}</span>
      <div className="stars">
        {[1, 2, 3, 4, 5].map((value) => (
          <button
            key={value}
            type="button"
            disabled={saving}
            onMouseEnter={() => setHover(value)}
            onMouseLeave={() => setHover(0)}
            onClick={() => rate(value)}
            className={(hover || Math.round(meal.averageRating || 0)) >= value ? "active" : ""}
          >
            ★
          </button>
        ))}
      </div>
      <small>{meal.averageRating ? `${meal.averageRating}/5 · ${meal.ratingCount}` : t("noRatingYet")}</small>
    </div>
  );
}
